module.exports = __webpack_public_path__ + "img/service03.1c37ea44.png";